import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ArticleServices from "../../../../services/ArticleService";
import { useTranslation } from "react-i18next";
import ArticleForm from "./articleForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import * as VarietyService from "../../../../services/VarietyService";

const ArticleFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [varieties, setVarieties] = useState([]);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      code: data.code,
      name: data.name,
      varietyUuid: data.varietyUuid,
      active: data.active,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultItems = await VarietyService.getAllVarieties({
      filters: { active: true },
    });
    if (resultItems && resultItems.length > 0) {
      const dataVarieties = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setVarieties(dataVarieties);
    }
    if (uuid) {
      const result = await ArticleServices.getArticle(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await ArticleServices.updateArticle(values, uuid);
        } else {
          result = await ArticleServices.addArticle(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.article.messages.update.title");
            text = t("forms.article.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.article.messages.create.title");
            text = t("forms.article.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.article.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.ARTICLE_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.ARTICLE_LIST);
  };

  return (
    <ArticleForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
      varieties={varieties}
    />
  );
};

ArticleFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ArticleFormContainer;
